import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { AtividadeCalendarModule } from '../../../atividade/calendar';
import { AtividadeChecklistItemModule } from '../../../atividade/checklist-item';
import { AtividadeFilterModule } from '../../../atividade/filter';
import { AtividadeFormModalModule } from '../../../atividade/form-modal';
import { AtividadeListModule } from '../../../atividade/list';
import { AtividadeTipoPipeModule } from '../../../atividade/tipo';
import { AtividadeVisualizacaoModule } from '../../../atividade/visualizacao';

import { ClienteAtividadeComponent } from './cliente-atividade.component';

@NgModule({
    imports: [
        SharedModule,
        AtividadeFormModalModule,
        AtividadeFilterModule,
        AtividadeVisualizacaoModule,
        AtividadeCalendarModule,
        AtividadeListModule,
        AtividadeTipoPipeModule,
        AtividadeChecklistItemModule
    ],
    declarations: [
        ClienteAtividadeComponent
    ],
    exports: [
        ClienteAtividadeComponent
    ]
})
export class ClienteAtividadeModule { }
